var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.incomingOrdersAmount > 0),expression:"incomingOrdersAmount > 0"}],class:[
    _vm.css(),
    ( _obj = {}, _obj[_vm.css('', 'collapsed')] = _vm.sidebarIsCollapsed, _obj ) ]},[_vm._v(" "+_vm._s(_vm.incomingOrdersAmount)+" "),_c('AudioNotification',{attrs:{"play":_vm.incomingOrdersAmount > 0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }